<template>
  <vue3-snackbar bottom right :duration="4000"></vue3-snackbar>
  <router-view />
</template>

<style>
:root {
  --background-color: #0D1A1A;
  --color-primary: #14cc8f;
  --color-secondary: #1F2626;
  --color-hover: #2d3838;
  --color-border: #2D3838;
  --color-icon: #7B9999;
  --color-text-secondary: #A3BFBA;
  --white: #F7FAF9;
  --default-border-radius: 28px
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  transition: .2s all;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--white);
}

body {
  background-color: var(--background-color);
  overflow-x: hidden;
}

.d-flex {
  display: flex;
}

a {
  color: var(--color-primary);
  text-decoration: none;
}

::selection {
  background-color: var(--color-hover);
  color: var(--white);
}

button {
  cursor: pointer;
  background-color: var(--background-color);
  border: 1px solid var(--color-border);
  color: var(--color-icon);
  border-radius: var(--default-border-radius);
  line-height: 30px;
  padding: 4px 10px;
}

button.primary {
  background-color: var(--color-primary);
  color: #000;
}

.w-100 {
  width: 100%;
}

button:hover {
  background-color: var(--color-hover);
}

button.primary:hover {
  color: var(--white);
  background-color: #238c69;
}

.d-flex.main {
  gap: 20px;
}

.vertical-center {
  max-width: 700px;
  margin: 120px auto;
  padding: 10px 20px;
}

p {
  font-size: 16px;
  color: var(--color-text-secondary)
}

p:not(.message-wrapper p) {
  margin-top: 18px;
}

.message.ai .message-wrapper p {
  color: #000;
  margin-bottom: 8px;
}

.message.ai .message-wrapper h3 {
  margin-top: 16px;
}

ul,
ol {
  margin: 10px 10px 23px 40px;
}

li {
  margin-bottom: 8px;
}

hr {
  color: #000;
  margin: 12px auto;
}

@media only screen and (max-width: 810px) {
  .side {
    position: fixed;
    z-index: 99999;
    width: 100%;
  }

  p {
    font-size: 16px;
  }

  h1 {
    margin-bottom: 24px;
  }
}
</style>
